import { Component, OnInit, Input } from '@angular/core';

export interface SectionImagemData {
  image: string;
}

@Component({
  selector: 'fcp-section-imagem',
  templateUrl: './section-imagem.component.html',
  styleUrls: ['./section-imagem.component.scss']
})
export class SectionImagemComponent implements OnInit {

  @Input() public sectionImagem: SectionImagemData;

  constructor() { }

  ngOnInit(): void {
  }

}
